<template>
  <div class="relative" ref="dropdownRef">
    <button
      type="button"
      @click="isOpen = !isOpen"
      class="flex items-center gap-2 px-3 py-3 bg-gray-50 border border-r-0 border-gray-200 rounded-l-xl hover:bg-gray-100 transition-colors focus:outline-none focus:ring-2 focus:ring-primary-200 focus:z-10"
    >
      <span class="text-xl leading-none">{{ selectedCountry.flag }}</span>
      <span class="text-sm font-medium text-gray-700">{{
        selectedCountry.dial_code
      }}</span>
      <ChevronDown
        :size="14"
        class="text-gray-400"
        :class="{ 'rotate-180': isOpen }"
      />
    </button>

    <div
      v-if="isOpen"
      class="absolute left-0 top-full mt-2 w-64 bg-white rounded-xl shadow-2xl border border-gray-100 overflow-hidden z-[9999] max-h-80 overflow-y-auto"
      style="background-color: white;"
    >
      <div class="p-2 sticky top-0 bg-white border-b border-gray-50">
        <div class="relative">
          <Search
            :size="14"
            class="absolute left-3 top-1/2 -translate-y-1/2 text-gray-400"
          />
          <input
            v-model="search"
            type="text"
            placeholder="Search country..."
            class="w-full pl-9 pr-3 py-2 text-sm bg-gray-50 rounded-lg border-none focus:ring-2 focus:ring-primary-100 outline-none"
            @click.stop
          />
        </div>
      </div>
      <div class="py-1">
        <button
          v-for="country in filteredCountries"
          :key="country.code"
          type="button"
          @click="selectCountry(country)"
          class="w-full flex items-center gap-3 px-4 py-2 hover:bg-gray-50 transition-colors text-left"
          :class="{ 'bg-primary-50': country.code === selectedCountry.code }"
        >
          <span class="text-xl leading-none">{{ country.flag }}</span>
          <span class="flex-grow text-sm text-gray-900">{{
            country.name
          }}</span>
          <span class="text-xs font-semibold text-gray-400">{{
            country.dial_code
          }}</span>
        </button>
      </div>
    </div>
  </div>
</template>

<script>
import { COUNTRIES } from "@/helpers/phoneUtils";
import { ChevronDown, Search } from "lucide-vue";

export default {
  name: "CountryCodeDropdown",
  components: {
    ChevronDown,
    Search
  },
  props: {
    value: {
      type: Object,
      required: true
    }
  },
  data() {
    return {
      isOpen: false,
      search: "",
      countries: COUNTRIES
    };
  },
  computed: {
    selectedCountry() {
      return this.value;
    },
    filteredCountries() {
      if (!this.search) return this.countries;
      const lowerSearch = this.search.toLowerCase();
      return this.countries.filter(
        (c) =>
          c.name.toLowerCase().includes(lowerSearch) ||
          c.dial_code.includes(this.search) ||
          c.code.toLowerCase().includes(lowerSearch)
      );
    }
  },
  mounted() {
    document.addEventListener("click", this.handleClickOutside);
  },
  beforeDestroy() {
    document.removeEventListener("click", this.handleClickOutside);
  },
  methods: {
    selectCountry(country) {
      this.$emit("input", country);
      this.isOpen = false;
      this.search = "";
    },
    handleClickOutside(event) {
      if (
        this.$refs.dropdownRef &&
        !this.$refs.dropdownRef.contains(event.target)
      ) {
        this.isOpen = false;
      }
    }
  }
};
</script>

<style scoped>
.rotate-180 {
  transform: rotate(180deg);
}
</style>
